<template>
	<div>
		<div v-for="(item, index) in form" :key="item.id">
			<div class="row" v-if="permitirExcluir">
				<div class="col-xs-12" style="margin: 0">
					<button
						class="btn btn-danger pull-right"
						@click="clickExcluirAbastecimento(item, index)"
						style="font-size: 14px"
						v-tooltip="_traducao('global', 'excluir')"
					>
						<i class="fa fa-fw fa-trash" />
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.numero_ce != null}"
				>
					<label>* {{ _traducao('global', 'numeroDeCE') }}:</label>
					<input v-model="item.numero_ce" class="form-control" />
					<p class="help-block" v-if="item.erro.numero_ce != null">
						{{ item.erro.numero_ce }}
					</p>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12" style="margin-top: 10px">
				<button
					class="btn btn-info btn-sm"
					type="button"
					@click="clickAddAbastecimento()"
				>
					<i class="fa fa-fw fa-plus"/>
					{{
						_traducao('global', 'adicionarAbastecimento').toUpperCase()
					}}
				</button>
			</div>
		</div>
		<movimentacoes-combustivel
			ref="movimentacoesCombustivel"
			@selecionou-movimentacao="(data) => movimentacaoSelecionado(data)"
		/>
	</div>
</template>

<script>
import mixinsAbastecimento from './mixinsAbastecimento.js'
import movimentacoesCombustivel from '../informacoes-movimentacoes-combustivel.vue'
export default {
	name: 'ComponenteBasicoAbastecimento',
	mixins: [mixinsAbastecimento],
	components: {
		movimentacoesCombustivel
	},
	props: {
		dadosAbastecimento: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		trecho: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		permitirExcluir: {
			default: true,
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			form: [],
			abastecimentoIndex: 0,
			showCamera: false,
			showCameraAnexos: false,
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			urlExcluir: 'mg-siga/Relatorio_voo_trecho/excluir_anexo_abastecimento',
			urlExcluirAnexo: 'mg-siga/Relatorio_voo_trecho/excluir_anexo',
		}
	},
	watch: {
		dadosAbastecimento: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.form = this.dadosAbastecimento
				}
			}
		}
	},
	methods: {
		async validadorFormAbastecimento() {
			if (await this.validarComponenteAbastecimento()) {
				this.$emit('abastecimento-valido', this.form);
			} else {
				this.$emit('abastecimento-invalido', false);
			}
		},

		async validarComponenteAbastecimento(){
			var passou = true
			var obrigatorio = this._traducao('global', 'obrigacao') 

			const qtd_abastecimento = this.form.length
			for (let abastecimento = 0; abastecimento < qtd_abastecimento; abastecimento++) {
				if (this.form[abastecimento].numero_ce == null) {
					this.form[abastecimento].erro.numero_ce = obrigatorio
					passou = false
				} else {
					this.form[abastecimento].erro.numero_ce = null
				}
			}
      
			return passou
		},
		
		carregaListaAnexo(anexosMovimentacao, index){
			if (this.$refs.anexos) {
				this.$refs.anexos[index].carregaLista(anexosMovimentacao)
			}
		}
	}
}
</script>

<style scoped>

</style>